
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2025.
 * Title: prod.EmmeEvolution_Marketplace.ts;
 * Path: ./src/environments/prod.EmmeEvolution_Marketplace.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 31/03/26, 11:53;
 * Updated at: 31/03/26, 11:53;
 *
 */

import { environment as Env } from './BaseEnvironments/EmmeEvolution_Marketplace';
import { getModule } from './Utility/ModuleUtility';
import {Permission} from "../app/Login/_guards/Permission";
import {VerticalNavigationComponent} from "../app/layouts/vertical-header/vertical-navigation.component";
import {GlobalStoreService} from "../app/shared/_services/global-store.service";
import {NotificationsComponent} from "../app/shared/Notifications/notifications.component";

var Environment = () => {
  var env = {
    ...Env,
    websocketUrl: 'wss://partner.ioneeo.com:8889/app',
    broadcastAuthUrl: 'https://partner.ioneeo.com/marketplace-chat/broadcasting/auth',
    reverbKey: 'lxv9fzkgfgjyjk0j5j7f',
    Alerts:[
      {
        restRoute: '/task/notifiche/list',
        icon: 'far fa-bell',
        params: (x: GlobalStoreService)=>{
          return {page: 1, size: 10, cliente: x.authSvc.currentUserValue['negozioId']??x.authSvc.currentUserValue.id , }
        },
        map: (x) => { return x?.data?.filter(y=>!y.letto)?.map(y => { return { ...y, value: y?.nome } }) },
        id: 'alerts',
        canRead: (x, permission: Permission) => true,
        onClick: (x, component: NotificationsComponent) => {
          component.api.ClassicPost('/task/notifiche/letto', { id: x.id }).subscribe(y =>
            component.notifiche.splice(component.notifiche.findIndex(z => z.value == x.value), 1)
          )
        },
        trigger: 'taskList'
      }
    ]
  };
  env.apiUrl = 'https://partner.ioneeo.com/api';

  return env;
};

export var environment = getModule(Environment());
